import React, { useState } from "react";
import { Send, CheckCircle2, FileClock } from "lucide-react";
import { eFilings as seed } from "../mock";
import { Button } from "../components/ui/button";
import { useToast } from "../hooks/use-toast";

const fmt = (n) => (n ? "RM " + Number(n).toLocaleString("en-MY", { minimumFractionDigits: 2 }) : "-");

const ETaxFiling = () => {
  const { toast } = useToast();
  const [rows, setRows] = useState(seed);

  const submit = (id) => {
    setRows((prev) =>
      prev.map((r) =>
        r.id === id
          ? {
              ...r,
              status: "Submitted",
              ackNo: `ACK-${r.form}-${r.ya}-${String(Math.floor(Math.random() * 900000 + 100000))}`,
              submittedDate: new Date().toISOString().slice(0, 10),
            }
          : r
      )
    );
    toast({ title: "Submitted to LHDN (mock)", description: "e-Filing acknowledgement generated." });
  };

  return (
    <div className="max-w-[1200px] mx-auto">
      <div className="flex items-center gap-3 mb-5">
        <div className="w-10 h-10 rounded bg-[#1877c9] text-white flex items-center justify-center">
          <Send size={20} />
        </div>
        <div>
          <h1 className="text-xl font-semibold text-gray-800">e-Tax Filing</h1>
          <p className="text-sm text-gray-500">Submit returns and track acknowledgements (LHDN e-Filing)</p>
        </div>
      </div>

      <div className="bg-white border border-gray-200 rounded-sm shadow-sm overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-[#f7f9fc] text-gray-600 text-left">
              <th className="px-4 py-3 font-medium">Company</th>
              <th className="px-4 py-3 font-medium">Form</th>
              <th className="px-4 py-3 font-medium">YA</th>
              <th className="px-4 py-3 font-medium">Ack. No.</th>
              <th className="px-4 py-3 font-medium">Submitted</th>
              <th className="px-4 py-3 font-medium">Tax Payable</th>
              <th className="px-4 py-3 font-medium">Status</th>
              <th className="px-4 py-3 font-medium text-right">Action</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} className="border-t border-gray-100 hover:bg-[#f9fbfe]">
                <td className="px-4 py-3 font-medium text-gray-800">{r.company}</td>
                <td className="px-4 py-3">{r.form}</td>
                <td className="px-4 py-3">{r.ya}</td>
                <td className="px-4 py-3 font-mono text-xs text-gray-500">{r.ackNo}</td>
                <td className="px-4 py-3 text-gray-600">{r.submittedDate}</td>
                <td className="px-4 py-3 font-mono">{fmt(r.taxPayable)}</td>
                <td className="px-4 py-3">
                  <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs ${r.status === "Submitted" ? "bg-green-100 text-green-700" : "bg-gray-100 text-gray-600"}`}>
                    {r.status === "Submitted" ? <CheckCircle2 size={12} /> : <FileClock size={12} />}
                    {r.status}
                  </span>
                </td>
                <td className="px-4 py-3 text-right">
                  {r.status !== "Submitted" ? (
                    <Button size="sm" onClick={() => submit(r.id)} className="bg-[#1877c9] hover:bg-[#0f5ea3] gap-1 h-8">
                      <Send size={14} /> Submit
                    </Button>
                  ) : (
                    <span className="text-xs text-gray-400">Completed</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ETaxFiling;
